/**
 * icons mapped from the editor. based on packages/@paraplegie_ch/gutenberg_blocks/src/utils/icons.ts
 * @todo: add them to the schema but can't do it currently because of the hyphen in the keys (not allowed in GraphQL)
 */function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
import { IconAddUser } from "./IconAddUser";
import { IconBecomeMember } from "./IconBecomeMember";
import { IconCalendar } from "./IconCalendar";
import { IconCardPayment } from "./IconCardPayment";
import { IconCheckmark } from "./IconCheckmark";
import { IconCompanyMember } from "./IconCompanyMember";
import { IconCouple } from "./IconCouple";
import { IconDeskWheelChair } from "./IconDeskWheelChair";
import { IconDoctor } from "./IconDoctor";
import { IconDonate } from "./IconDonate";
import { IconEditUser } from "./IconEditUser";
import { IconFacebook } from "./IconFacebook";
import { IconGift } from "./IconGift";
import { IconHeart } from "./IconHeart";
import { IconInstagram } from "./IconInstagram";
import { IconNews } from "./IconNews";
import { IconSignPost } from "./IconSignPost";
import { IconTwitter } from "./IconTwitter";
import { IconWheelChair } from "./IconWheelChair";
import { IconYoutube } from "./IconYoutube";
export var IconType;
(function (IconType) {
  IconType["add-user"] = "add-user";
  IconType["become-member"] = "become-member";
  IconType["calendar"] = "calendar";
  IconType["card-payment"] = "card-payment";
  IconType["checkmark"] = "checkmark";
  IconType["company-member"] = "company-member";
  IconType["couple"] = "couple";
  IconType["desk-wheelchair"] = "desk-wheelchair";
  IconType["doctor"] = "doctor";
  IconType["donate"] = "donate";
  IconType["edit-user"] = "edit-user";
  IconType["facebook"] = "facebook";
  IconType["gift"] = "gift";
  IconType["heart"] = "heart";
  IconType["instagram"] = "instagram";
  IconType["news"] = "news";
  IconType["signpost"] = "signpost";
  IconType["twitter"] = "twitter";
  IconType["wheel-chair"] = "wheel-chair";
  IconType["youtube"] = "youtube";
})(IconType || (IconType = {}));
var _obj;
var IconsMap = (_obj = {}, _define_property(_obj, "add-user", IconAddUser), _define_property(_obj, "become-member", IconBecomeMember), _define_property(_obj, "calendar", IconCalendar), _define_property(_obj, "card-payment", IconCardPayment), _define_property(_obj, "checkmark", IconCheckmark), _define_property(_obj, "company-member", IconCompanyMember), _define_property(_obj, "couple", IconCouple), _define_property(_obj, "desk-wheelchair", IconDeskWheelChair), _define_property(_obj, "doctor", IconDoctor), _define_property(_obj, "donate", IconDonate), _define_property(_obj, "edit-user", IconEditUser), _define_property(_obj, "facebook", IconFacebook), _define_property(_obj, "gift", IconGift), _define_property(_obj, "heart", IconHeart), _define_property(_obj, "instagram", IconInstagram), _define_property(_obj, "news", IconNews), _define_property(_obj, "signpost", IconSignPost), _define_property(_obj, "twitter", IconTwitter), _define_property(_obj, "wheel-chair", IconWheelChair), _define_property(_obj, "youtube", IconYoutube), _obj);
export var CustomIcon = function CustomIcon(_param) {
  var icon = _param.icon,
    props = _object_without_properties(_param, ["icon"]);
  var _IconsMap_icon;
  var Icon = (_IconsMap_icon = IconsMap[icon]) !== null && _IconsMap_icon !== void 0 ? _IconsMap_icon : null;
  return Icon ? /*#__PURE__*/React.createElement(Icon, _object_spread_props(_object_spread({}, props), {
    "aria-hidden": true
  })) : null;
};